import React from 'react';
import clientsImage from '../assets/images/clients.png';

const Clients = () => {
    return (
        <section id="clients" className="py-24 bg-white">
            <div className="container mx-auto px-6 md:px-12">
                <h2 className="text-[#f39c12] text-3xl md:text-5xl font-bold mb-12 md:mb-16 uppercase text-center tracking-[0.1em] md:tracking-[0.2em]">
                    Clients
                </h2>

                <div className="flex justify-center items-center">
                    <img
                        src={clientsImage}
                        alt="Our Clients"
                        className="max-w-full h-auto drop-shadow-sm"
                    />
                </div>
            </div>
        </section>
    );
};

export default Clients;

